import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";
import {getParam} from "../../components/Utils/Utils";

const selectApprovalProcesses = async (search, pageable) => {
    try {
        return await needAuth.post(`/approvalProcesses?${getParam(pageable)}`, search);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
};

const getApprovalProcessById = async (id) => {
    try {
        return await needAuth.get(`/approvalProcesses/${id}`);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

export {
    selectApprovalProcesses,
    getApprovalProcessById,
};
